module.exports = __webpack_public_path__ + "static/media/logo-login.d62f14bf.svg";